import { z } from 'zod';
import { isoTimestampSchema, uuidSchema } from './common';

const dateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'YYYY-MM-DD');

/**
 * A branch's audit trail for managers (`audit.read`): who did what, when and why. Newest first,
 * paged by `cursor` (the last id of the previous page). Dates are branch business days.
 */
export const branchAuditQuerySchema = z.object({
  from: dateSchema.optional(),
  to: dateSchema.optional(),
  /** Action prefix, e.g. `payment.` or `bill.voided`. */
  action: z.string().trim().min(1).max(80).optional(),
  entity_id: z.string().trim().min(1).max(64).optional(),
  cursor: uuidSchema.optional(),
});

export const auditEntrySchema = z.object({
  id: uuidSchema,
  action: z.string(),
  entity_type: z.string(),
  entity_id: z.string(),
  actor_user_id: z.string().nullable(),
  actor_name: z.string().nullable(),
  reason: z.string().nullable(),
  changes: z.record(z.string(), z.unknown()).nullable(),
  request_id: z.string(),
  created_at: isoTimestampSchema,
});
export type AuditEntry = z.infer<typeof auditEntrySchema>;

export const auditListResponseSchema = z.object({
  items: z.array(auditEntrySchema),
  next_cursor: uuidSchema.nullable(),
});
